import React, { useEffect, useState } from 'react';
import BASE_URL from '../config';

const ShowSolar = () => {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${BASE_URL}api/proxy?action=latest_solardata`)
      .then(res => res.json())
      .then(data => {
        if (data.data) setRecords(data.data);
        else setError('No data found.');
      })
      .catch(() => setError('Failed to fetch data.'));
  }, []);

  const formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    return date.toLocaleString();
  };

  return (
    <div className="container mt-4">
      <h5>Latest Solar Records</h5>
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-striped table-bordered table-sm" style={{ whiteSpace: 'nowrap' }}>
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>Created At</th>
              <th>Lead Date</th>
              <th>Credit</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>City</th>
              <th>State</th>
              <th>ZIP</th>
              <th>Street Address</th>
              <th>Home Phone</th>
              <th>Electricity Provider</th>
              <th>Roof Shade</th>
              <th>Home Owner</th>
              <th>Power Bill</th>
              <th>Email</th>
              <th>Jornaya Lead ID</th>
              <th>IP</th>
              <th>TrustedForm</th>
              <th>Unsubscribe</th>
              <th>Unsub Date</th>
              <th>UOpened</th>
              <th>Opened</th>
              <th>Clicked</th>
              <th>UClicked</th>
              <th>Unsub</th>
              <th>Bounced</th>
              <th>Spam</th>
              <th>Unsub</th>
              <th>Bounced</th>
              <th>Spam</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row, i) => (
              <tr key={i}>
                <td>{row.nId}</td>
                <td>{formatDate(row.createdat)}</td>
                <td>{formatDate(row.leaddate)}</td>
                <td>{row.credit}</td>
                <td>{row.firstname}</td>
                <td>{row.lastname}</td>
                <td>{row.city}</td>
                <td>{row.state}</td>
                <td>{row.zip}</td>
                <td>{row.streetaddress}</td>
                <td>{row.homephone}</td>
                <td>{row.electricityprovider}</td>
                <td>{row.roofshade}</td>
                <td>{row.homeowner}</td>
                <td>{row.powerbill}</td>
                <td>{row.emailaddress}</td>
                <td>{row.jornayaleadidtoken}</td>
                <td>{row.ipaddress}</td>
                <td>
                  {row.trustedformurl && (
                    <a href={row.trustedformurl} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  )}
                </td>
                <td>{row.unsubscribe}</td>
                <td>{formatDate(row.unsubdate)}</td>
                <td>{row.UOpened}</td>
                <td>{row.Opened}</td>
                <td>{row.Clicked}</td>
                <td>{row.UClicked}</td>
                <td>{row.Unsub}</td>
                <td>{row.Bounced}</td>
                <td>{row.Spam}</td>
                <td>{row.Unsub}</td>
                <td>{row.Bounced}</td>
                <td>{row.Spam}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowSolar;
